import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Close = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L20 18.5858L33.2929 5.29289C33.6834 4.90237 34.3166 4.90237 34.7071 5.29289C35.0976 5.68342 35.0976 6.31658 34.7071 6.70711L21.4142 20L34.7071 33.2929C35.0976 33.6834 35.0976 34.3166 34.7071 34.7071C34.3166 35.0976 33.6834 35.0976 33.2929 34.7071L20 21.4142L6.70711 34.7071C6.31658 35.0976 5.68342 35.0976 5.29289 34.7071C4.90237 34.3166 4.90237 33.6834 5.29289 33.2929L18.5858 20L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Close;
